<div class="text-center" [class.refer--list]="showimg==4">
  <img src="assets/img/svg/no-data-details.svg" style="max-width: 250px; width: 100%;padding-top: 10rem;" *ngIf="showimg==1">
  <img src="assets/img/svg/no-data-found.svg" style="max-width: 250px; width: 100%;padding-top: 10rem;" *ngIf="showimg==2">
  <!-- <h2 class=" mt-4">{{ desc }}</h2> -->
  <img src="assets/img/svg/no-data-details.svg" style="max-width: 170px; width: 100%;padding-top: 10rem;" *ngIf="showimg==3">
  <p style="font-size: 22px; font-weight: 700; line-height: 1.5;" *ngIf="showimg!=4">No data yet</p>
  <h4 class=" mt-4" *ngIf="showimg==3">{{ desc }}</h4>
  <h4 *ngIf="desc==''">Please contact <span class="notranslate">Denefits</span> <a href="/app/help/support"> Support</a> to enable this feature.</h4>
  <ng-container *ngIf="showimg==4">
    <img src="assets/img/svg/no-data-details.svg">
    <h4>{{desc}}</h4>
  </ng-container>
</div>
